
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { update, detail, add, dropdownOfEnterprise } from './api'
import { required } from '@/utils/rules'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
    isType: {
      type: String,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const rules = {
      deviceNo: [required],
      status: [required],
    }
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        dropdownOfEnterprise({ value: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.key,
            }
          })
        })
      },
    })
    const data = reactive({
      visible: false,
      titlename: '编辑',
      formRef: undefined,
      formData: ref<any>({}),
      typeOpt: [
        {
          label: '正常',
          value: '1',
        },
        {
          label: '禁用',
          value: '2',
        },
        {
          label: '报废',
          value: '3',
        },
      ],
      provinceOpt: [
        { label: '山东', value: '山东' },
        { label: '福建', value: '福建' },
        { label: '河北', value: '河北' },
        { label: '河南', value: '河南' },
        { label: '重庆', value: '重庆' },
        { label: '湖北', value: '湖北' },
        { label: '湖南', value: '湖南' },
        { label: '江西', value: '江西' },
        { label: '海南', value: '海南' },
        { label: '黑龙江', value: '黑龙江' },
        { label: '天津', value: '天津' },
        { label: '贵州', value: '贵州' },
        { label: '陕西', value: '陕西' },
        { label: '新疆', value: '新疆' },
        { label: '江苏', value: '江苏' },
        { label: '安徽', value: '安徽' },
        { label: '西藏', value: '西藏' },
        { label: '吉林', value: '吉林' },
        { label: '上海', value: '上海' },
        { label: '甘肃', value: '甘肃' },
        { label: '山西', value: '山西' },
        { label: '宁夏', value: '宁夏' },
        { label: '四川', value: '四川' },
        { label: '广西', value: '广西' },
        { label: '浙江', value: '浙江' },
        { label: '云南', value: '云南' },
        { label: '内蒙古', value: '内蒙古' },
        { label: '辽宁', value: '辽宁' },
        { label: '广东', value: '广东' },
        { label: '青海', value: '青海' },
        { label: '北京', value: '北京' },
      ],
      name: '',
      companyUuid: '',
      id: props.row.id,
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
      emit('onSuccess')
    }
    // 提交表单
    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const p: any = { ...data.formData }
          if (p.companyUuid === data.name) {
            console.log('相同')
            p.companyUuid = data.companyUuid
            console.log(p.companyUuid)
          }
          console.log(p.companyUuid)

          if (p.status === '正常') {
            p.status = 1
          } else if (p.status === '禁用') {
            p.status = 2
          } else if (p.status === '报废') {
            p.status = 3
          }
          let handleFn = add // 赋值接口方法
          if (props.isType === 'edit') {
            handleFn = update
          }
          if (props.isType === 'add') {
            delete p.id
          }
          const [err] = await toResult(handleFn(p))
          if (err) return false
          ElMessage.success('操作成功')
          onCancel()
        }
      })
    }

    // 初始化
    const init = async () => {
      if (props.isType === 'add') {
        data.titlename = '新增'
      } else if (props.isType === 'edit') {
        const p = { id: data.id }
        const [err, res] = await toResult(detail(p))
        if (err) return false
        data.titlename = '编辑'
        data.formData = props.row
        data.formData.remark = res.remark
        data.companyUuid = props.row.companyUuid
        data.formData.companyUuid = res.companyName
        data.name = res.companyName
        if (props.row.status === 1) {
          data.formData.status = '正常'
        } else if (props.row.status === 2) {
          data.formData.status = '禁用'
        } else if (props.row.status === 3) {
          data.formData.status = '报废'
        }
      }
    }

    onMounted(() => {
      init()
    })
    return {
      ...toRefs(data),
      handleSubmit,
      onCancel,
      remoteData1,
      rules,
    }
  },
})
